
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { DepartmentItemProps } from ".";
import { loading, create } from "store/department";

interface ApiDepartmentCreateInputProps extends Omit<DepartmentItemProps, "id"> {
}

type ApiDepartmentCreateOutputProps = OutputBaseProps<{ item: DepartmentItemProps; }, DepartmentItemProps>;

export const apiDepartmentCreate = async (data: ApiDepartmentCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiDepartmentCreateOutputProps>("/api/department/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
    }
    return res;
};